/*
 * Focus Trap helpers
 */

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  first.focus();
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, wait) {
  let t = false;
  return (...args) => {
    if (!t) {
      fn.apply(this, args)
      t = true;
      setTimeout(() => t = false, wait)
    }
  }
}

function handleize(str) {
  str = str
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // Remove accents
    .replace(/([^\w]+|\s+)/g, "-") // Replace space and other characters by hyphen
    .replace(/\-\-+/g, "-") // Replaces multiple hyphens by one hyphen
    .replace(/(^-+|-+$)/g, "") // Remove extra hyphens from beginning or end of the string
    .toLowerCase(); // To lowercase

  return str;
}

/*
 * Woolman Common JS
 */

// Initialize window.Woolman object
if (typeof window.Woolman == 'undefined') {
  window.Woolman = {};
}
Woolman.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

// -------
// Load components / libraries
Woolman.init = function () {
  Woolman.ModalsAndDrawers.init();
  Woolman.Header.init();
  Woolman.DetailsAccordions.init();
  Woolman.CustomSelect.init();

   // Attach theme editor listeners
   if (!Shopify || !Shopify.designMode) return;

  let lastSelection = {
    sectionId: undefined,
    blockId: undefined
  };

  // Load is called when something is changed within section settings
  document.addEventListener('shopify:section:load', (evt) => {
    const sectionId = 'shopify-section-' + evt.detail.sectionId
    if (sectionId === Woolman.Header.cache.section.id) {
      Woolman.ModalsAndDrawers.init();
      Woolman.Header.init();
    }

    if (document.querySelector(`[data-modal][data-section-id="${evt.detail.sectionId}"]`)) {
      Woolman.ModalsAndDrawers.showModalOrDrawer(document.querySelector(`[data-modal][data-section-id="${evt.detail.sectionId}"]`).id);
    }

    console.log('shopify:section:load sectionId', evt.detail.sectionId)
    console.log('lastSelection', lastSelection)
  })

  document.addEventListener('shopify:block:select', (evt) => {
    const sectionId = 'shopify-section-' + evt.detail.sectionId
    const blocks = document.getElementById(sectionId).querySelectorAll('[data-shopify-editor-block]')
    const selectedBlock = [...blocks].find(x => JSON.parse(x.dataset.shopifyEditorBlock).id === evt.detail.blockId);
    if (sectionId === Woolman.Header.cache.section.id) {
      if (selectedBlock) {
        // Make sure menu is open
        Woolman.Header.cache.openButton.click();

        // Select menu item
        const accordion = selectedBlock.closest('[data-accordion-item]').querySelector('input');
        const label = selectedBlock.closest('[data-accordion-item]').querySelector('label');
        if (!accordion.checked) label.click();
      }
    } else if (sectionId.includes('modal') && document.getElementById(sectionId).querySelector('[data-modal]')) {
      if (selectedBlock) {
        Woolman.ModalsAndDrawers.showModalOrDrawer(document.getElementById(sectionId).querySelector('[data-modal]').id);
      }
    }

    lastSelection.sectionId = evt.detail.sectionId;
    lastSelection.blockId = evt.detail.blockId;
    console.log('shopify:block:select', evt.detail.sectionId, evt.detail.blockId)
    console.log('lastSelection', lastSelection)
  })

  document.addEventListener('shopify:section:unload', (evt) => {
    console.log('shopify:section:unload sectionId', evt.detail.sectionId)
  })

  document.addEventListener('shopify:section:select', (evt) => {
    console.log('shopify:section:select', evt.detail.sectionId)
    lastSelection = {
      sectionId: evt.detail.sectionId,
      blockId: evt.detail.blockId
    }

    if (evt.detail.sectionId.includes('modal') && document.querySelector(`[data-modal][data-section-id="${evt.detail.sectionId}"]`)) {
      Woolman.ModalsAndDrawers.showModalOrDrawer(document.querySelector(`[data-modal][data-section-id="${evt.detail.sectionId}"]`).id);
    }

    console.log('lastSelection', lastSelection)
  })

  document.addEventListener('shopify:section:deselect', (evt) => {
    console.log('shopify:section:deselect', evt.detail.sectionId)
    lastSelection = {
      sectionId: undefined,
      blockId: undefined
    }

    if (evt.detail.sectionId.includes('modal') && document.querySelector(`[data-modal][data-section-id="${evt.detail.sectionId}"]`)) {
      Woolman.ModalsAndDrawers.closeModalOrDrawer(document.querySelector(`[data-modal][data-section-id="${evt.detail.sectionId}"]`).id);
    }

    console.log('lastSelection', lastSelection)
  })
};

// -------
// Woolman Common JS - Utility library
Woolman.Utils = {
  debugMode: true,
  prepareQueryParams: () => {
    Shopify.queryParams = Shopify.queryParams || {};

    // Preserve existing query parameters
    if (location.search.length) {
      const params = location.search.substr(1).split('&');
      for (let i = 0; i < params.length; i++) {
        const keyValue = params[i].split('=');
        // Spaces are reverted back after the decode, since in component-facets.js we'll use URLSearchParams() method and we don't want to double decode the spaces
        if (keyValue.length) {
          Shopify.queryParams[decodeURIComponent(keyValue[0])] = decodeURIComponent(keyValue[1]).replaceAll('+', ' ');
        }
      }
    }

    return Shopify.queryParams;
  },
  formatMoney(cents, format) {
    const default_money_format = theme.settings.moneyFormat || '€{{amount}}';
    if (typeof cents == 'string') {
      cents = cents.replace('.', '');
    }
    if (window?.Shopify?.currency?.rate) {
      cents = cents * parseFloat(window.Shopify.currency.rate || 1.0);
    }

    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || default_money_format;

    function defaultOption(opt, def) {
      return typeof opt == 'undefined' ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? decimal + parts[1] : '';

      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  },
    checkCart: function () {
    const run = () => Promise.race([
      this._checkCart(),
      new Promise(resolve => setTimeout(resolve, 8000))
    ]);
    this._cartQueue = (this._cartQueue || Promise.resolve()).then(run, run);
    return this._cartQueue;
  },
  _removeLine: async function (oldKey, oldVariantId, oldSellingPlanId) {
    // Line keys can change when a new line is added (for example when a discount code is applied),
    // so read the cart again and find the old line by product and plan before removing it.
    for (let attempt = 0; attempt < 2; attempt++) {
      const cart = await fetch(`${routes.cart_url}.json?t=${Date.now()}`).then(r => r.json());
      const line = cart.items.find(i => i.key === oldKey) ||
        cart.items.find(i => i.variant_id === oldVariantId &&
          (i.selling_plan_allocation ? i.selling_plan_allocation.selling_plan.id : null) === oldSellingPlanId);
      if (!line) return;
      try {
        await this.changeItem(line.key, 0);
        return;
      } catch (error) {
        if (attempt === 1) throw error;
      }
    }
  },
  _checkCart: async function () {
    try {
      const response = await fetch(`${routes.cart_url}.json`);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const cartData = await response.json();

      // Calculate the total quantity of items in the cart
      const totalQuantity = cartData.items.reduce((sum, item) => sum + item.quantity, 0);

      if (totalQuantity > 1) {
        const sleeveProducts = cartData.items.filter(item => item.properties['_sleeve_variant']);
        const linesToUpdate = [];

        for (const item of sleeveProducts) {
          const sleeveProductVariantId = item.properties['_sleeve_variant'] && parseInt(item.properties['_sleeve_variant']);
          const sleeveSellingPlans = JSON.parse(item.properties['_sleeve_variant_selling_plans'] || '[]');
          const originalSellingPlanName = item.selling_plan_allocation ? item.selling_plan_allocation.selling_plan.name : null;

          if (item.variant_id !== sleeveProductVariantId) {
            const sleeveSellingPlan = sleeveSellingPlans.find(plan => plan.name === originalSellingPlanName);

            linesToUpdate.push({
              id: item.key,
              oldVariantId: item.variant_id,
              oldSellingPlanId: item.selling_plan_allocation ? item.selling_plan_allocation.selling_plan.id : null,
              quantity: item.quantity,
              properties: item.properties,
              newId: sleeveProductVariantId,
              newSellingPlanId: sleeveSellingPlan ? sleeveSellingPlan.id : null
            });
          }
        }

        for (const line of linesToUpdate) {
          // Add the new item first, so a qualifying product is always in the cart (keeps the free gift)
          await this.addItem(line.newId, line.quantity, {...line.properties}, line.newSellingPlanId);
          // Then remove the old item
          await this._removeLine(line.id, line.oldVariantId, line.oldSellingPlanId);
        }
      } else if (totalQuantity === 1) {
        const item = cartData.items[0];
        const originalVariantId = item.properties['_original_variant'] && parseInt(item.properties['_original_variant']);
        const originalSellingPlans = JSON.parse(item.properties['_original_variant_selling_plans'] || '[]');

        if (originalVariantId && item.variant_id !== originalVariantId) {
          const sleeveSellingPlanName = item.selling_plan_allocation ? item.selling_plan_allocation.selling_plan.name : null;
          const originalSellingPlan = originalSellingPlans.find(plan => plan.name === sleeveSellingPlanName);

          // Add the pre-packed item first, then remove the sleeve
          await this.addItem(originalVariantId, item.quantity, {...item.properties}, originalSellingPlan ? originalSellingPlan.id : null);
          await this._removeLine(item.key, item.variant_id, item.selling_plan_allocation ? item.selling_plan_allocation.selling_plan.id : null);
        }
      }
    } catch (error) {
      console.error('Error fetching cart data:', error);
      return false;
    }
  },
  addItem: function (key, qty, properties = null, selling_plan = null) {
    return this._updateCart({
      url: `${window.routes.cart_add_url}.json?t=${Date.now()}`,
      data: {
        id: key,
        quantity: qty,
        ...(properties && { properties }),
        ...selling_plan && {
          selling_plan: selling_plan,
        }
      },
    });
  },
  changeItem: function (key, qty, properties = null, selling_plan = null) {
    return this._updateCart({
      url: `${window.routes.cart_change_url}.json?t=${Date.now()}`,
      data: {
        id: key,
        quantity: qty,
        ...(properties && { properties }),
        ...selling_plan && {
          selling_plan: selling_plan,
        }
      },
    });
  },
  _updateCart: function ({ url, data }) {
    return fetch(url, {
      method: 'POST',
      body: JSON.stringify(data),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    })
      .then(response => {
        if (!response.ok) {
          return Promise.reject(new Error(response.statusText));
        }
        return response.json();
      })
      .catch(error => {
        console.error('Error updating cart:', error);
        throw error;
      });
  },
};

Woolman.CustomSelect = {
  init: () => {
    document.querySelectorAll('[data-custom-select]').forEach(select => {
      Woolman.CustomSelect.initSingleSelect(select);
    });
  },
  
  initSingleSelect: (select) => {
    EasySelect.init(`#${select.id}`, {
      align: select.dataset.align ?? 'left',
      onInit: data => {
        document.dispatchEvent(new CustomEvent(`kalla:custom-select-init.${select.id}`));
        
        if (!data.instance.originalSelectTag.dataset.customSelectLabel) {
          return;
        }
        
        data.instance.current.dataset.label = data.instance.originalSelectTag.dataset.customSelectLabel;
      },
      onChange: data => {
        data.instance.originalSelectTag.value = data.value;
        data.instance.originalSelectTag.dispatchEvent(new Event('change'));
      },
      customDropDownOptionHTML: option => {
        let html = option.innerHTML;

        return html;
      }
    });
  }
}

// -------
// Woolman Common JS - Header component
Woolman.Header = {
  selectors: {
    header: 'MainHeader',
    cartBlip: '.cart-blip'
  },
  cache: {
    header: undefined,
    cartBlip: undefined,
    section: undefined,
    openButton: undefined
  },

  init: function () {
    this.cache.header = document.getElementById(this.selectors.header);
    this.cache.cartBlip = this.cache.header.querySelector(this.selectors.cartBlip);
    this.cache.section = this.cache.header.closest('.shopify-section');
    this.cache.openButton = this.cache.header.querySelector('[href="#drawer-menu"]')

    // Update cart blip when product is added to cart.
    document.addEventListener('ajaxProduct:added', this.updateCartBlip.bind(this))
    document.addEventListener('cart:update', this.updateCartBlip.bind(this));

    if (this.cache.header.dataset.stickyBehavior === 'none') return;
    this.initStickyBehavior(this.cache.header.dataset.stickyBehavior)
  },

  initStickyBehavior(behaviorType) {
    const stickyConfig = {
      headerHeight: this.cache.header.clientHeight,
      behavior: behaviorType
    }

    document.documentElement.classList.add('sticky-header-initialized', `sticky-header-${behaviorType}`);
    document.documentElement.style.setProperty('--sticky-header-margin-top', `${stickyConfig.headerHeight}px`);

    if (behaviorType === 'scroll' || behaviorType === 'fixed') {
      // Show on scroll fixed header
      let prevScroll = window.scrollY || document.documentElement.scrollTop;
      let curScroll;
      let direction = 0;
      let prevDirection = 0;

      /*
      ** Find the direction of scroll
      ** 0 - initial, 1 - up, 2 - down
      */

      const toggleStickyHeader = (direction, curScroll) => {
        if ((direction === 1) || curScroll < stickyConfig.headerHeight) {
          document.documentElement.classList.remove('sticky-header-hide')
        } else if (direction === 2 && curScroll > stickyConfig.headerHeight) {
          document.documentElement.classList.add('sticky-header-hide')
        }

        prevDirection = direction;
      }

      window.addEventListener('scroll', throttle(() => {
        curScroll = window.scrollY || document.documentElement.scrollTop;

        if (curScroll >= 300) {
          document.documentElement.classList.add('sticky-header-show')
        } else {
          document.documentElement.classList.remove('sticky-header-show');
        }

        if (curScroll > prevScroll) {
          direction = 2; // user scrolling down
        } else {
          direction = 1; // user scrolling up
        }

        if (direction !== prevDirection && behaviorType === 'scroll') {
          toggleStickyHeader(direction, curScroll)
        }

        prevScroll = curScroll
      }, 50))

      setInterval(() => {
        if (direction === 2 && behaviorType === 'scroll' && curScroll >= 900) {
          toggleStickyHeader(direction, curScroll);
        }
        if (window.scrollY === 0) {
          document.documentElement.classList.remove('sticky-header-show', 'sticky-header-hide');
        }
      }, 200)
    }
  },

  async updateCartBlip(e) {
    const cart = e.detail && e.detail.cart && e.detail.cart.item_count || await (async function () {
      const res = await fetch('/cart.json');
      const cart = await res.json();
      return cart;
    })();

    this.cache.cartBlip.textContent = cart.item_count || 0;
    if (cart && cart.item_count == 0) {
      this.cache.cartBlip.setAttribute('hidden', true);
      this.cache.cartBlip.closest('.header-item__link').classList.remove('has-blip-visible');
    } else {
      this.cache.cartBlip.removeAttribute('hidden')
      this.cache.cartBlip.closest('.header-item__link').classList.add('has-blip-visible');
    }

    // Update notification cart amount at the same time (if present)
    const total_in_notification = document.querySelector('#cart-notification-link .cart-total');
    if (total_in_notification) {
      total_in_notification.textContent = cart.item_count;
    }
  }
};

// -------
// Woolman Common JS - Modals & drawers library
Woolman.ModalsAndDrawers = {
  settings: {
    selectors: {
      modalLink: 'a[href*="#modal"]:not(.quick-buy_link)',
      drawerLink: 'a[href*="#drawer"]',
    },
  },
  focusTraps: {},
  init: function () {
    // Init open event listeners
    document.querySelectorAll(this.settings.selectors.modalLink).forEach((modalLink) => {
      modalLink.addEventListener('click', (event) => {
        event.preventDefault();
        const targetId = event.currentTarget.getAttribute('href').substring(1).split('?')[0];
        const slideIndex = event.currentTarget.getAttribute('href').substring(1).split('?slide=')[1];
        const scrollToId = event.currentTarget.getAttribute('href').substring(1).split('?scroll=')[1];
        this.showModalOrDrawer(targetId, parseInt(slideIndex), scrollToId);
      });
    });

    document.querySelectorAll(this.settings.selectors.drawerLink).forEach((drawerLink) => {
      drawerLink.addEventListener('click', (event) => {
        event.preventDefault();
        const targetId = event.currentTarget.getAttribute('href').substring(1).split('?')[0];
        this.showModalOrDrawer(targetId);
      });
    });

    // Init close event listeners
    const closeBtns = document.querySelectorAll('[data-close]');
    if (closeBtns) {
      closeBtns.forEach((closeBtn) => {
        closeBtn.addEventListener('click', this.closeModalOrDrawerOrDrawerFromEvent.bind(this));
      });
    }

    const overlays = document.querySelectorAll('[data-overlay]');
    if (overlays) {
      overlays.forEach((overlay) => {
        overlay.addEventListener('click', this.closeModalOrDrawerOrDrawerFromEvent.bind(this));
      });
    }

    // Escape to close all
    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' || event.keyCode === 27) {
        document.querySelectorAll('.drawer').forEach((drawer) => {
          drawer.classList.remove('is-open');
        });
        document.querySelectorAll('.modal').forEach((modal) => {
          modal.classList.remove('is-open');
        });
        document.body.classList.remove('overflow-hidden');
      }
    });
  },
  /**
   *
   * @param {string} targetId - ID of modal or drawer element, e.g. modal-geo, drawer-menu
   * @param {int} slideIndex - Index of a Gridy Slider slide inside the opened modal - (sliding motion)
   * @param {string} scrollToId - ID of a Gridy Slider slide inside the opened modal - (no motion)
   * Traps focus to modal and disables body scrolling.
   */
  showModalOrDrawer: function (targetId, slideIndex, scrollToId) {
    const targetElement = document.getElementById(targetId);
    if (!targetElement && Woolman.Utils.debugMode) {
      console.warn('No modal/drawer element specified');
    }
    if (!targetElement) {
      return;
    }

    if (targetElement.classList.contains('is-open')) return;

    targetElement.classList.add('initialized', 'is-open');
    document.body.classList.add('overflow-hidden');

    setTimeout(() => {
      trapFocus(targetElement);

      // Focus on drawerSearchInput if it exists
      const drawerSearchInput = targetElement.querySelector('#drawerSearchInput');
      if (drawerSearchInput) {
        drawerSearchInput.focus();
      }
    }, 600);

    if (slideIndex) {
      setTimeout(() => {
        const gridySlider = targetElement.querySelector('gridy-slider');
        gridySlider.scrollToSlide(slideIndex - 1);
      }, 600);
    } else if (scrollToId) {
      const scrollToElement = document.getElementById(scrollToId),
            modal_dialog = targetElement.querySelector('.gridy-track');

      modal_dialog.scrollTo({
        top: scrollToElement.offsetTop,
        left: scrollToElement.offsetLeft,
        behavior: "instant"
      });
    }
  },
  closeModalOrDrawer: function(targetId) {
    const targetElement = document.getElementById(targetId);
    targetElement.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
  },
  closeModalOrDrawerOrDrawerFromEvent: function (event) {
    event.preventDefault();
    removeTrapFocus();
    const parentElement = event.currentTarget.closest('[data-parent]');
    parentElement.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
  }
};

/**
 * Allow us to trigger something when window is actually resized.
 */
let woolman_window_size = window.innerWidth;
window.addEventListener(
  'resize',
  debounce(() => {
    if (window.innerWidth == woolman_window_size) {
      return;
    }
    woolman_window_size = window.innerWidth;
    document.dispatchEvent(new CustomEvent('woolman:resize'));
  }),
  250
);

/**
 * Animated details element
 */
class Accordion {
  constructor(el) {
    this.el = el;
    this.summary = el.querySelector('summary');
    this.content = el.querySelector('.content');

    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.summary.addEventListener('click', (e) => this.onClick(e));
    this.toggleByViewport();
    document.addEventListener('woolman:resize', this.toggleByViewport.bind(this));
  }

  onClick(e) {
    e.preventDefault();
    this.el.style.overflow = 'hidden';
    if (this.isClosing || !this.el.open) {
      this.open();
    } else if (this.isExpanding || this.el.open) {
      this.shrink();
    }
  }

  shrink() {
    this.isClosing = true;

    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight}px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.el.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 400,
      easing: 'ease-in-out'
    });

    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => this.isClosing = false;
  }

  open() {
    this.el.style.height = `${this.el.offsetHeight}px`;
    this.el.open = true;
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    this.isExpanding = true;
    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.el.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 400,
      easing: 'ease-out'
    });
    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => this.isExpanding = false;
  }

  onAnimationFinish(open) {
    this.el.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.el.style.height = this.el.style.overflow = '';
  }

  toggleByViewport() {
    let mobileClose = this.el.dataset.mobileClose != undefined ? JSON.parse(this.el.dataset.mobileClose) : false;
    let desktopOpen = this.el.dataset.desktopOpen != undefined ? JSON.parse(this.el.dataset.desktopOpen) : false;

    if (woolman_window_size >= 768 && desktopOpen) {
      this.el.open = true;
    } else if (mobileClose) {
      this.el.open = false;
    }
  }
};

Woolman.DetailsAccordions = {
  init: function () {
    document.querySelectorAll('details').forEach((el) => {
      new Accordion(el);
    });
  }
};

Woolman.init();

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="locale_code"], input[name="country_code"]')
    };

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;

    // Filter params fix, replace "%2C" with ","
    let return_to_value = form.querySelector('[name="return_to"]').value;
    let indexOfFilters = return_to_value.indexOf("?filter");
    if (indexOfFilters !== -1) {
        let substringAfterFilters = return_to_value.substring(indexOfFilters);
        let replacedSubstring = substringAfterFilters.replace(/%2C/g, ",");
        form.querySelector('[name="return_to"]').value = return_to_value.substring(0, indexOfFilters) + replacedSubstring;
    }

    if (form) form.submit();
  }
}

customElements.define('localization-form', LocalizationForm);

// Custom element that enhances HTML Video Element functionality.
// Usage: <video is="superpowered-video">
class SuperPoweredVideo extends HTMLElement {
  constructor() {
    super();

    this.video = this.querySelector('video') || this.querySelector('iframe');
    this.container = this.closest('.video-container') || null;

    if (this.container) this.attachClickListener(this.closest('.video-container'));

    // check if video is iframe and has a src and that src is youtube
    if (this.video.nodeName === 'IFRAME' && this.video.src && this.video.src.includes('youtube') && !this.container) {
      this.video.addEventListener('load', this.onVideoLoad.bind(this));
    }

    // When video is out of viewport pause it. This is to prevent videos from playing in the background.
    // If video is in viewport play it.
    // Use: Intersection Observer API
    const autoplay = this.dataset.autoplay || false;
    if (!autoplay || this.container) return;

    const videoType = this.video.nodeName === 'VIDEO' ? 'video' : 'iframe';
    const videoHost = this.video.nodeName === 'VIDEO' ? 'shopify' : (this.video.src.includes('youtube') ? 'youtube' : 'vimeo');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (videoType == 'video') {
            this.video.play();
          } else if (videoHost == 'youtube') {
            this.video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
          } else if (videoHost == 'vimeo') {
            this.video.contentWindow.postMessage('{"method":"play"}', '*');
          }
        } else {
          if (videoType == 'video') {
            this.video.pause()
          } else if (videoHost == 'youtube') {
            this.video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          } else if (videoHost == 'vimeo') {
            this.video.contentWindow.postMessage('{"method":"pause"}', '*');
          }
        }
      });
    } , { threshold: 0.5 });

    observer.observe(this.video);
  }

  attachClickListener(videoContainer) {
    if (!videoContainer) return;
    videoContainer.addEventListener('click', (e) => {
      if (this.video.paused) {
        this.video.play();
      } else {
        this.video.pause();
      }
    });

    this.video.onplay = () => {
      videoContainer.querySelector('button').hidden = true;
    }

    this.video.onpause = () => {
      videoContainer.querySelector('button').hidden = false;
    }
  }

  onVideoLoad() {
    // force youtube to play on mobile
    this.video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
  }
}
customElements.define('superpowered-video', SuperPoweredVideo);

// Gridy Slider - a custom Woolman built slider.
// Usage: <gridy-slider>
class GridySlider extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.track = this.querySelector('.gridy-track');
    this.slides = this.querySelectorAll('.gridy-track > *');

    this.arrows = this.querySelector('.gridy-arrows');

    const data_ipr_desktop = parseInt(this.dataset.iprDesktop, 10) || 1;
    const data_ipr_tablet = parseInt(this.dataset.iprTablet, 10) || data_ipr_desktop;
    const data_ipr_mobile = parseInt(this.dataset.iprMobile, 10) || 1;
    const data_init_scroll_to = this.dataset.initScrollTo;
    const data_autoplay = this.dataset.autoplay != undefined ? JSON.parse(this.dataset.autoplay) : false;
    const data_autoplay_delay = parseInt(this.dataset.autoplayDelay, 10) || 5000;
    const data_is_thumbnails_slider = this.dataset.thumbnailsFor != undefined ? true : false;
    const data_indicator = this.dataset.indicator != undefined ? JSON.parse(this.dataset.indicator) : false;
    const data_sliding_behavior = this.dataset.slidingBehavior;
    const data_thumbnail_slider = document.getElementById(`thumbnail-${this.id}`);
    const data_track_overflow_visible = this.dataset.overflowVisible != undefined ? true : false;
    const data_card_type = this.dataset.cardType != undefined ? this.dataset.cardType : false;

    this.config = {
      slide_count: this.slides.length,
      current_slide: 0,
      active_slide_offset: 0,

      ipr_desktop: data_ipr_desktop,
      ipr_tablet: data_ipr_tablet,
      ipr_mobile: data_ipr_mobile,
      breakpoint_tablet: 768,
      breakpoint_desktop: 1024,

      arrows: true,
      autoplay: data_autoplay || false,
      autoplay_delay: data_autoplay_delay,
      timer: null,

      is_thumbnails_slider: data_is_thumbnails_slider,
      thumbnails_for: undefined,
      thumbnail_slider: data_thumbnail_slider,

      indicator: data_indicator,
      track_overflow_visible: data_track_overflow_visible,
      sliding_behavior: data_sliding_behavior || 'all',
    };

    if (data_init_scroll_to != undefined) {
      this.scrollToSlideByID(data_init_scroll_to);
    }

    if (this.config.arrows) {
      this.buttons = this.querySelectorAll('[data-gridy-arrow]');
      this.handleArrowClick = this.onArrowClick.bind(this);

      this.buttons.forEach(arrowButton => {
        arrowButton.addEventListener('click', this.handleArrowClick);
      });
    }

    if (this.config.autoplay) {
      this.autoplayGridy();
      this.addEventListener('mouseenter', this.clearAutoplayTimer);
      this.addEventListener('mouseleave', this.autoplayGridy);
      this.addEventListener('touchenter', this.clearAutoplayTimer);
      this.addEventListener('touchleave', this.autoplayGridy);
    }

    if (this.config.is_thumbnails_slider) {
      this.config.active_slide_offset = 2;
      this.config.thumbnails_for = document.getElementById(this.dataset.thumbnailsFor);
      this.thumbnail = this.querySelectorAll('[data-thumbnail-btn]');
      this.thumbnail.forEach(thumbnail => {
        thumbnail.addEventListener('click', this.onThumbnailClick.bind(this));
      });
    }

    if (this.config.indicator) {
      this.indicator_dots = this.querySelectorAll('[data-indicator-dot]');
      this.indicator_current = this.querySelector('[data-indicator-current]');
    }

    if (!this.config.is_thumbnails_slider) {
      let scrollTimeout;
      this.track.addEventListener('scroll', () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(this.afterScrollStops.bind(this), 200);
      });
    }

    window.addEventListener('resize', this.adjustArrowsPosition.bind(this));
    this.adjustArrowsPosition();
  }

  reset(scrollToFirstSlide = true) {
    if (this.config.autoplay && this.config.timer) {
      this.clearAutoplayTimer();
    }

    this.removeEventListener('mouseenter', this.clearAutoplayTimer);
    this.removeEventListener('mouseleave', this.autoplayGridy);
    this.removeEventListener('touchenter', this.clearAutoplayTimer);
    this.removeEventListener('touchleave', this.autoplayGridy);
    this.track.removeEventListener('scroll', this.afterScrollStops);

    if (this.config.arrows) {
      this.buttons.forEach(arrowButton => {
        arrowButton.removeEventListener('click', this.handleArrowClick);
      });
    }

    scrollToFirstSlide && this.scrollToSlide(0);

    this.slides.forEach(item => {
      item.classList.remove('active');
    });

    this.track = null;
    this.slides = null;
    this.buttons = null;
    this.thumbnail = null;
    this.indicator_dots = null;
    this.indicator_current = null;

    this.init();
  }

  afterScrollStops() {
    let slideInView = this.firstSlideInView();
    this.config.current_slide = slideInView;
    this.setActiveSlide(this.slides[slideInView + this.config.active_slide_offset]);

    if (this.config.thumbnail_slider) {
      this.config.thumbnail_slider.scrollToSlide(slideInView);
    }
  }

  autoplayGridy() {
    this.config.timer = setInterval(this.scrollByIPR.bind(this), this.config.autoplay_delay, 'next');
  }

  clearAutoplayTimer() {
    clearInterval(this.config.timer);
    this.config.timer = null;
  }

  onThumbnailClick(event) {
    event.preventDefault();
    this.config.current_slide = Array.from(event.currentTarget.parentNode.children).indexOf(event.currentTarget);
    this.config.thumbnails_for.scrollToSlideByID(event.currentTarget.dataset.itemId);
    this.scrollToSlide(this.config.current_slide);
  }

  onArrowClick(event) {
    this.scrollByIPR(event.currentTarget.dataset.direction);
  }

  scrollByIPR(direction) {
    let currentIPR = this.getCurrentIPR(),
      slideMultiplier = this.config.sliding_behavior == 'all' ? currentIPR : 1,
      newCurrentSlide = this.config.current_slide,
      lastToShow = this.config.slide_count - currentIPR;

    /* 
      Used to check the next visible slide. If the next slide is not visible, it will skip to the next visible slide.
      This is used on PDP where we render all the images, but show only the images of the selected variant.
    */

    const isSlideVisible = index => {
      const slide = this.slides[index];
      return slide && window.getComputedStyle(slide).display !== 'none';
    };

    if (direction === 'next') {
      for (let i = 0; i < slideMultiplier; i++) {
        newCurrentSlide++;
        if (newCurrentSlide > lastToShow) {
          newCurrentSlide = 0;
        }
        while (!isSlideVisible(newCurrentSlide)) {
          newCurrentSlide++;
          if (newCurrentSlide > lastToShow) {
            newCurrentSlide = 0;
          }
        }
      }
    } else if (direction === 'prev') {
      for (let i = 0; i < slideMultiplier; i++) {
        newCurrentSlide--;
        if (newCurrentSlide < 0) {
          newCurrentSlide = lastToShow;
        }
        while (!isSlideVisible(newCurrentSlide)) {
          newCurrentSlide--;
          if (newCurrentSlide < 0) {
            newCurrentSlide = lastToShow;
          }
        }
      }
    }
    this.config.current_slide = newCurrentSlide;
    this.scrollToSlide(newCurrentSlide);
  }

  scrollToSlide(newPosition) {
    if (isNaN(newPosition)) {
      return;
    }

    let slidePosWithOffset = newPosition - this.config.active_slide_offset,
      newScrollToSlidePos = slidePosWithOffset > 0 ? slidePosWithOffset : 0;

    const slideInNewScrollToPos = this.slides[newScrollToSlidePos];

    if (!slideInNewScrollToPos) return;

    let scrollToLeft = slideInNewScrollToPos.offsetLeft,
      scrollToTop = slideInNewScrollToPos.offsetTop;

    if (this.config.track_overflow_visible) {
      scrollToLeft = this.slides[newScrollToSlidePos].offsetLeft - this.slides[0].offsetLeft;
    }

    this.track.scrollTo({
      left: scrollToLeft,
      top: scrollToTop,
      behavior: 'smooth',
    });

    this.slides.forEach(item => {
      item.classList.remove('active');
    });

    this.slides[newPosition].classList.add('active');

    this.config.current_slide = newPosition;
    this.setActiveSlide(this.slides[newPosition]);
  }

  scrollToSlideByID(slideID) {
    const theSlide = document.getElementById(slideID),
      newPosition = Array.from(theSlide.parentNode.children).indexOf(theSlide);
    this.scrollToSlide(newPosition);
  }

  setActiveSlide(slide) {
    this.slides.forEach(item => {
      item.classList.remove('active');
    });

    slide.classList.add('active');

    if (this.config.indicator) {
      if (this.indicator_current) {
        this.indicator_current.textContent = this.config.current_slide + 1;
      }

      if (this.indicator_dots) {
        this.indicator_dots.forEach(dot => {
          dot.classList.remove('active');
        });

        if (this.indicator_dots[this.config.current_slide]) {
          this.indicator_dots[this.config.current_slide].classList.add('active');
        }
      }
    }
  }

  getCurrentIPR() {
    let currentIPR = this.config.ipr_mobile;
    if (woolman_window_size >= this.config.breakpoint_desktop) {
      currentIPR = this.config.ipr_desktop;
    } else if (woolman_window_size >= this.config.breakpoint_tablet) {
      currentIPR = this.config.ipr_tablet;
    }
    return currentIPR;
  }

  firstSlideInView() {
    let loopIndex = 0;
    for (const slide of this.slides) {
      if (this.isSlideInView(slide)) {
        return loopIndex;
      }
      ++loopIndex;
    }
    return this.config.current_slide;
  }

  isSlideInView(slide) {
    const containerBounds = this.track.getBoundingClientRect();
    const slideBounds = slide.getBoundingClientRect();

    const isSlideVisible =
      Math.round(slideBounds.top) >= Math.floor(containerBounds.top) &&
      Math.floor(slideBounds.bottom) <= Math.round(containerBounds.bottom) &&
      Math.round(slideBounds.left) >= Math.floor(containerBounds.left) &&
      Math.floor(slideBounds.right) <= Math.round(containerBounds.right) &&
      window.getComputedStyle(slide).display !== 'none';

    return isSlideVisible;
  }

  adjustArrowsPosition() {
    const firstMediaItem = this.querySelector('.card-media');

    if (!firstMediaItem) return;

    const height = firstMediaItem.offsetHeight;

    this.arrows.style.top = `${height / 2}px`;
  }
}

customElements.define('gridy-slider', GridySlider);


// Tab Container - a custom Woolman built container for content in tabs.
// Usage: <tab-container>
class TabContainer extends HTMLElement {
  constructor() {
    super();

    this.track = this.querySelector('[data-tab-titles]');
    this.slides = this.querySelectorAll('[data-tab-titles] > *');

    this.config = {
      breakpoint_tablet: 768
    }

    this.querySelectorAll('[data-tab-title]').forEach((button) => button.addEventListener('click', this.onButtonClick.bind(this)));
  }

  scrollToTitle(newPosition) {
    if (isNaN(newPosition)) {
      return;
    }

    if (window.innerWidth >= this.config.breakpoint_tablet) {
      return;
    }

    const slideInNewScrollToPos = this.slides[newPosition];
    const scrollToLeft = this.slides[newPosition].offsetLeft - this.slides[0].offsetLeft;
    const scrollToTop = slideInNewScrollToPos.offsetTop;

    this.track.scrollTo({
      left: scrollToLeft,
      top: scrollToTop,
      behavior: "smooth",
    });
  }

  onButtonClick(event) {
    const id = event.target.closest('button').getAttribute('data-tab-title');
    const titleElems = Array.from(this.querySelectorAll('[data-tab-title]'));
    const contentElems = this.querySelectorAll('[data-tab-content]');
    const collectionLinkElems = this.querySelectorAll('[data-tab-collection-link]');
    const elementIndex = titleElems.findIndex(elem => elem.getAttribute('data-tab-title') === id);

    titleElems.forEach(elem => {
      if (elem.getAttribute('data-tab-title') === id) {
        elem.classList.remove('style--subdued');
        elem.classList.add('is-active');
      } else {
        elem.classList.add('style--subdued');
        elem.classList.remove('is-active');
      }
    })

    contentElems.forEach(elem => {
      elem.getAttribute('data-tab-content') === id
        ? elem.classList.remove('hidden')
        : elem.classList.add('hidden')
    })

    collectionLinkElems.forEach(elem => {
      elem.getAttribute('data-tab-collection-link') === id
        ? elem.classList.remove('hidden')
        : elem.classList.add('hidden')
    })

    this.scrollToTitle(elementIndex)
  }
}
customElements.define('tab-container', TabContainer);


// QuantityInput for + and - button functionality
// Used in: cart items, upsell items
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.querySelectorAll('button').forEach((button) => button.addEventListener('click', this.onButtonClick.bind(this)));
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}
customElements.define('quantity-input', QuantityInput);

class CustomDropdown extends HTMLElement {
  constructor() {
    super();

    this.id = this.getAttribute('id');
    this.selectedValue = '';
    this.isOpen = false;
    this.placeholderString = this.getAttribute('placeholder') ?? 'Select option';

    this.button = this.querySelector('.custom-dropdown__button');
    this.itemsContainer = this.querySelector('.custom-dropdown__content');
    this.relatedSelect = document.getElementById(this.getAttribute('select-id'));
    this.originalFormButton = document.querySelector('.product-form__submit');
    this.placeHolderAddToCart = this.originalFormButton.innerHTML;

    if (!this.itemsContainer) {
      return;
    }

    this.initSelectedValue();

    this.button.addEventListener('click', this.toggleDropdown.bind(this));
    this.button.addEventListener('keydown', this.handleButtonKeydown.bind(this));
    this.itemsContainer.addEventListener('keydown', this.handleItemsContainerKeydown.bind(this));
    this.itemsContainer.addEventListener('click', this.handleItemClick.bind(this));
  }

  initSelectedValue() {
    if (this.relatedSelect) {
      const selectedOption = this.relatedSelect.querySelector('option[selected]');
      
      if (selectedOption) {
        const value = selectedOption.value;
        this.value = value;
      }
    }
  }

  toggleDropdown() {
    this.isOpen = !this.isOpen;
    this.updateDropdownState();

    if (this.isOpen) {
      document.addEventListener('click', this.handleDocumentClick);
    } else {
      document.removeEventListener('click', this.handleDocumentClick);
    }
  }

  closeDropdown() {
    this.isOpen = false;
    this.updateDropdownState();
    this.dispatchCloseEvent();
  }

  updateDropdownState() {
    this.itemsContainer.style.display = this.isOpen ? 'block' : 'none';
    this.button.setAttribute('aria-expanded', String(this.isOpen));
    this.itemsContainer.setAttribute('aria-hidden', String(!this.isOpen));
    this.classList.toggle('opened', this.isOpen);
  
    if (this.isOpen) {
      this.button.innerHTML = this.placeholderString;
      this.itemsContainer.focus();
    } else {
      const selectedOption = this.itemsContainer.querySelector('input[type="radio"]:checked');
      if (selectedOption) {
        this.button.innerHTML = selectedOption.nextElementSibling.querySelector('[data-option-html]')
          ? selectedOption.nextElementSibling.querySelector('[data-option-html]').innerHTML.trim()
          : selectedOption.nextElementSibling.innerHTML.trim();
      } else {
        this.button.innerHTML = this.placeholderString;
      }
    }
  }

  handleButtonKeydown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.toggleDropdown();
    }
  }

  handleItemsContainerKeydown(event) {
    const currentIndex = Array.from(this.itemsContainer.children).indexOf(document.activeElement);

    if (event.key === 'ArrowUp' && currentIndex > 0) {
      event.preventDefault();
      this.itemsContainer.children[currentIndex - 1].focus();
    } else if (event.key === 'ArrowDown' && currentIndex < this.itemsContainer.children.length - 1) {
      event.preventDefault();
      this.itemsContainer.children[currentIndex + 1].focus();
    } else if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.selectOption(document.activeElement);
    }
  }

  handleItemClick(event) {
    const option = event.target.closest('.custom-dropdown__item');

    if (option) {
      this.selectOption(option);
      this.updateNativeSelect(option);
      this.dispatchChangeEvent(option);
    }
  }

  handleDocumentClick = (event) => {
    if (!this.contains(event.target)) {
      this.closeDropdown();
    }
  }

  dispatchChangeEvent(option) {
    const customEvent = new CustomEvent(`custom-dropdown--${this.id}:change`, {
      bubbles: true,
      detail: { option },
    });
    this.dispatchEvent(customEvent);
  }

  dispatchCloseEvent() {
    const customEvent = new CustomEvent(`custom-dropdown--${this.id}:close`, {
      bubbles: true,
    });
    this.dispatchEvent(customEvent);
  }

  selectOption(option) {
    this.selectedValue = option.dataset.value;
    this.button.innerHTML = option.querySelector('[data-option-html]')
      ? option.querySelector('[data-option-html]').innerHTML.trim()
      : option.innerHTML.trim();
    Array.from(this.itemsContainer.children).forEach(item => {
      item.setAttribute('aria-selected', 'false');
    });
    option.setAttribute('aria-selected', 'true');
    !option.hasAttribute('data-prevent-auto-closing') && this.closeDropdown();
  }

  updateNativeSelect(option = null, value = null) {
    if (this.relatedSelect) {
      this.relatedSelect.value = value ?? option?.getAttribute('data-value');
      const changeEvent = new Event('change', { bubbles: true });
      this.relatedSelect.dispatchEvent(changeEvent);
    }
  }

  reset() {
    this.updateNativeSelect(null, 'default');

    this.button.innerHTML = this.placeholderString;
    Array.from(this.itemsContainer.children).forEach(item => {
      item.setAttribute('aria-selected', 'false');
    });
  }

  get value() {
    return this.selectedValue;
  }

  set value(newValue) {
    const option = this.itemsContainer.querySelector(`[data-value="${newValue}"]`);

    if (option) {
      this.selectOption(option);
      this.dispatchChangeEvent(option);
    }
  }
}

customElements.define('custom-dropdown', CustomDropdown);